import { render, staticRenderFns } from "./ProductDiscountModal.vue?vue&type=template&id=b067f0ee&scoped=true&"
import script from "./ProductDiscountModal.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscountModal.vue?vue&type=style&index=0&id=b067f0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b067f0ee",
  null
  
)

export default component.exports